module.exports = __webpack_public_path__ + "static/img/airfrieght-right.cdc1eac0.jpg";